export default __webpack_public_path__ + "static/media/icon-arrow.48ec7bbc.svg";